export class contactUs{
    mobileNumber: string;
    emailId: string;
    customerName: string;
    description: string;
}